import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBook = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 32,
	viewBox: "0 0 33 32",
	width: 33,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#005ce6",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "m26.3334 2h-20.00003c-.55312 0-1 .44687-1 1v26c0 .5531.44688 1 1 1h20.00003c.5531 0 1-.4469 1-1v-26c0-.55313-.4469-1-1-1zm-8.125 2.25h3v6.5594l-1.4532-1.0594-1.5468 1.1062zm-10.62503 23.5v-23.5h8.75003v9.2781c0 .1031.0312.2063.0937.2907.038.0536.0862.0992.1418.134.0557.0349.1177.0584.1825.0692.0648.0107.1311.0085.1951-.0065.0639-.0151.1243-.0426.1775-.0811l2.6187-1.8719 2.5438 1.8562c.0844.0625.1875.0969.2937.0969.275 0 .5-.225.5-.5v-9.2656h2v23.5z" }),
			/* @__PURE__ */ _jsx("path", {
				d: "m21.2084 10.8094v-6.5594h-3v6.6062l1.5468-1.1062z",
				opacity: .1
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "m23.0803 4.25v9.2656c0 .275-.225.5-.5.5-.1063 0-.2094-.0344-.2938-.0969l-2.5437-1.8562-2.6188 1.8719c-.0532.0385-.1136.066-.1775.0811-.064.015-.1303.0172-.1951.0065-.0648-.0108-.1268-.0343-.1825-.0692-.0556-.0348-.1038-.0804-.1418-.134-.0625-.0844-.0937-.1876-.0937-.2907v-9.2781h-8.75003v23.5h17.49693v-23.5z",
				opacity: .1
			})
		]
	})
});
export { SvgBook as ReactComponent };
